import { isNumber } from 'lodash';
import * as THREE from 'three';
import BaseMesh from './base-mesh';
class Ellipse3d extends BaseMesh {
    constructor(data) {
        super(data);
        const { renderProps, opacity = 1, zIndex } = this.props;
        const { colorStops, rotateX = 0, points } = renderProps;
        this.isObserver = true;
        const ellipseShape = new THREE.Shape();
        const center = new THREE.Vector2(points[0].x, points[0].z).add(new THREE.Vector2(points[1].x, points[1].z)).divideScalar(2);
        this.position.set(center.x, 0, center.y);
        this.rotation.x = Math.PI * rotateX;
        this.position.y = Math.max(points[0].y, points[1].y) + 1;
        const xAxis = Math.abs(center.x - points[0].x);
        const yAxis = Math.abs(center.y - points[0].z);
        ellipseShape.absellipse(0, 0, // ax, aY
        xAxis, yAxis, // xRadius, yRadius
        0, 2 * Math.PI, // aStartAngle, aEndAngle
        false, // aClockwise
        0);
        this.geometry = new THREE.ShapeGeometry(ellipseShape, 48);
        this.assignUVs(this.geometry);
        this.material = new THREE.MeshBasicMaterial({
            map: this._draw(Math.max(yAxis, xAxis), colorStops, 200),
            transparent: true,
            side: THREE.DoubleSide,
            depthTest: true,
            opacity,
        });
        // this.update(data);
    }
    assignUVs(geometry) {
        geometry.computeBoundingBox();
        const max = geometry.boundingBox.max;
        const min = geometry.boundingBox.min;
        const offset = new THREE.Vector2(0 - min.x, 0 - min.y);
        const range = new THREE.Vector2(max.x - min.x, max.y - min.y);
        const pointArray = geometry.attributes.position.array;
        const _uvs = [];
        const len = pointArray.length / 3;
        for (let i = 0; i < len; i++) {
            const v = i * 3;
            _uvs.push((pointArray[v] + offset.x) / range.x, (pointArray[v + 1] + offset.y) / range.y);
        }
        const uvs = new Float32Array(_uvs);
        geometry.attributes.uv = new THREE.BufferAttribute(uvs, 2);
        geometry.attributes.uv.needsUpdate = true;
    }
    update(data) {
        // super.update(data);
        const { renderProps, opacity = 1, zIndex, visible = true } = data;
        const { colorStops, rotateX = 0, points } = renderProps;
        const center = new THREE.Vector2(points[0].x, points[0].z).add(new THREE.Vector2(points[1].x, points[1].z)).divideScalar(2);
        const xAxis = Math.abs(center.x - points[0].x);
        const yAxis = Math.abs(center.y - points[0].z);
        this.material.map = this._draw(Math.max(yAxis, xAxis), colorStops, 200);
        this.visible = visible;
        this.props = data;
    }
    getMaxMin(value) {
        let min = Number.MAX_SAFE_INTEGER;
        let max = -Number.MAX_SAFE_INTEGER;
        min = Math.min(min, value);
        max = Math.max(max, value);
        return { max, min };
    }
    _draw(radius, colorStops, size) {
        const canvas = document.createElement('canvas');
        canvas.width = radius * 2;
        canvas.height = radius * 2;
        const colorCount = colorStops.length || 0;
        const context = canvas.getContext('2d');
        if (context) {
            context.beginPath();
            context.arc(radius, radius, radius, 0, 2 * Math.PI);
            context.closePath();
            // 创建渐变色: r,g,b取值比较自由，我们只关注alpha的数值
            const radialGradient = context.createRadialGradient(radius, radius, 0, radius, radius, radius);
            // 添加一个由偏移值和颜色值指定的断点到渐变
            // radialGradient.addColorStop(1.0, "#FF000000");
            colorStops.forEach(({ offset, color }, index) => {
                if (isNumber(offset) && color) {
                    radialGradient.addColorStop((1 / (colorCount + 1)) * index, color);
                }
                // radialGradient.addColorStop(offset * 0.95, color);
            });
            // radialGradient.addColorStop(0.95, 'rgba(0,0,0,0)');
            radialGradient.addColorStop(1, 'rgba(0,0,0,0)');
            context.fillStyle = radialGradient;
            // const { max, min } = this.getMaxMin(size);
            // // 设置globalAlpha: 需注意取值需规范在0-1之间
            // const globalAlpha = (size - min) / (max - min);
            // context.globalAlpha = Math.max(Math.min(globalAlpha, 1), 0);
            // 填充颜色
            context.fill();
            context.strokeStyle = 'rgba(0,0,0,0)';
            context.stroke();
            // const ctx = this.fillRoundRect(0, 0, 2, 2, 0.5, 'rgba(0,0,0,0.7)');
            // const pattern = context.createPattern(ctx, 'repeat') as CanvasPattern;
            // context.fillStyle = pattern;
            // context.fill();
        }
        const canvasTexture = new THREE.CanvasTexture(canvas);
        canvasTexture.encoding = THREE.sRGBEncoding;
        // canvasTexture.minFilter = THREE.NearestMipmapLinearFilter;
        // canvasTexture.magFilter = THREE.LinearFilter;
        canvasTexture.needsUpdate = true;
        return canvasTexture;
    }
    fillRoundRect(x, y, width, height, radius, /* optional */ fillColor) {
        const canvas = document.createElement('canvas');
        canvas.width = 1.5 * width;
        canvas.height = 1.5 * height;
        const context = canvas.getContext('2d');
        // 圆的直径必然要小于矩形的宽高
        if (2 * radius > width || 2 * radius > height) {
            return canvas;
        }
        if (context) {
            context.save();
            context.translate(x, y);
            // 绘制圆角矩形的各个边
            this.drawRoundRectPath(context, width, height, radius);
            context.fillStyle = fillColor || '#000'; // 若是给定了值就用给定的值否则给予默认值
            context.fill();
            context.restore();
        }
        return canvas;
    }
    drawRoundRectPath(cxt, width, height, radius) {
        cxt.beginPath();
        // 从右下角顺时针绘制，弧度从0到1/2PI
        cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);
        // 矩形下边线
        cxt.lineTo(radius, height);
        // 左下角圆弧，弧度从1/2PI到PI
        cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);
        // 矩形左边线
        cxt.lineTo(0, radius);
        // 左上角圆弧，弧度从PI到3/2PI
        cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);
        // 上边线
        cxt.lineTo(width - radius, 0);
        // 右上角圆弧
        cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);
        // 右边线
        cxt.lineTo(width, height - radius);
        cxt.closePath();
    }
    onMouseEnter() {
        document.body.style.cursor = 'pointer';
        super.onMouseEnter();
    }
    onMouseLeave() {
        document.body.style.cursor = '';
        super.onMouseLeave();
    }
    onClick() {
        super.onClick();
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default Ellipse3d;
